'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var dirBuilder = require('./dir');

var fileBuilder = require('./file');

function dagBuilder(_x, _x2, _x3) {
  return _dagBuilder.apply(this, arguments);
}

function _dagBuilder() {
  _dagBuilder = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, block, options) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _value;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context3.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var entry, _source, chunker, chunkValidator;

              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      entry = _value;

                      if (entry.path) {
                        if (entry.path.substring(0, 2) === './') {
                          options.wrapWithDirectory = true;
                        }

                        entry.path = entry.path.split('/').filter(function (path) {
                          return path && path !== '.';
                        }).join('/');
                      }

                      if (!entry.content) {
                        _context2.next = 11;
                        break;
                      }

                      _source = entry.content; // wrap in iterator if it is array-like or not an iterator

                      if (!_source[Symbol.asyncIterator] && !_source[Symbol.iterator] || _source.length !== undefined) {
                        _source = _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return entry.content;

                                case 2:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));
                      }

                      if (typeof options.chunker === 'function') {
                        chunker = options.chunker;
                      } else if (options.chunker === 'rabin') {
                        chunker = require('../chunker/rabin');
                      } else {
                        chunker = require('../chunker/fixed-size');
                      }

                      if (typeof options.chunkValidator === 'function') {
                        chunkValidator = options.chunkValidator;
                      } else {
                        chunkValidator = require('./validate-chunks');
                      } // item is a file


                      _context2.next = 9;
                      return function () {
                        return fileBuilder(entry, chunker(chunkValidator(_source, options), options), block, options);
                      };

                    case 9:
                      _context2.next = 13;
                      break;

                    case 11:
                      _context2.next = 13;
                      return function () {
                        return dirBuilder(entry, block, options);
                      };

                    case 13:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });
            _iterator = _asyncIterator(source);

          case 5:
            _context3.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            _step = _context3.sent;
            _iteratorNormalCompletion = _step.done;
            _context3.next = 11;
            return _awaitAsyncGenerator(_step.value);

          case 11:
            _value = _context3.sent;

            if (_iteratorNormalCompletion) {
              _context3.next = 17;
              break;
            }

            return _context3.delegateYield(_loop(), "t0", 14);

          case 14:
            _iteratorNormalCompletion = true;
            _context3.next = 5;
            break;

          case 17:
            _context3.next = 23;
            break;

          case 19:
            _context3.prev = 19;
            _context3.t1 = _context3["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context3.t1;

          case 23:
            _context3.prev = 23;
            _context3.prev = 24;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context3.next = 28;
              break;
            }

            _context3.next = 28;
            return _awaitAsyncGenerator(_iterator.return());

          case 28:
            _context3.prev = 28;

            if (!_didIteratorError) {
              _context3.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context3.finish(28);

          case 32:
            return _context3.finish(23);

          case 33:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[2, 19, 23, 33], [24,, 28, 32]]);
  }));
  return _dagBuilder.apply(this, arguments);
}

module.exports = dagBuilder;